import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import { canvas } from './rive';

class Card {
	constructor(el) {
		this.container = null;
		this.swipers = [];

		this.init(el);
	}

	init(el) {
		this.container = el;
		if (!this.container) return;

		el._cardInstance = this;
		this.isHovered = false;

		const cartContainer = el.querySelector('.card__cart');

		const sliderContainers = el.querySelectorAll('.swiper');

		for (const slider of sliderContainers) {
			const pagination = slider.nextElementSibling;
			if (!pagination || !pagination.classList.contains('swiper-pagination')) {
				continue;
			}

			const swiperInstance = new Swiper(slider, {
				modules: [Pagination],
				slidesPerView: 1,
				spaceBetween: 1,
				watchSlidesProgress: true,
				pagination: {
					el: pagination,
					type: 'bullets',
					clickable: true,
				},
			});

			this.swipers.push(swiperInstance);
			this.bindSlideHover(swiperInstance);
		}

		el.addEventListener('mouseenter', () => {
			cartContainer?.append(canvas);

			setTimeout(() => {
				this.isHovered = true;
				this.container.classList.add('_hovered');
			}, 300);
		});

		this.container.addEventListener('mouseleave', () => {
			setTimeout(() => {
				this.isHovered = false;
				this.container.classList.remove('_hovered');
			}, 300);
		});

		cartContainer?.addEventListener('click', () => {
			el.classList.add('_active');
			el.classList.add('_added');
		});
	}

	bindSlideHover(swiperInstance) {
		const hoverSlides = this.container.querySelectorAll('[data-hover-slide]');

		hoverSlides.forEach((item, index) => {
			item.addEventListener('mouseover', () => {
				if (!this.isHovered) {
					return;
				}

				swiperInstance.slideTo(index);
			});

			item.addEventListener('mouseleave', () => {
				swiperInstance.slideTo(0);
			});
		});
	}

	resetSwiper() {
		this.swipers.forEach((swiper) => {
			swiper.slideTo(0, 0);
			swiper.update();
		});
	}
}

document.querySelectorAll('[data-card]').forEach((el) => {
	el._cardInstance = new Card(el);
});

window.addEventListener('pageshow', (event) => {
	if (!event.persisted) return;

	document.querySelectorAll('[data-card]').forEach((el) => {
		el._cardInstance?.resetSwiper();
	});
});

export default Card;
